export enum EmailTemplate {
    LeaverToSupplier = 'leaver-to-supplier',
}
